/*
hold event data
*/
import DashboardDataService from "@/services/DashboardDataService";

import { UserGroup } from "@/services/UserGroups";
import { mapGetters } from "vuex";
import UtilityMixin from "@/mixins/UtilityMixin";
// @group Mixins
export default {
  mixins: [UtilityMixin],
  props: {
    defaultView: {
      type: Boolean
    },
    hideCustomerView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dashboardDataService: new DashboardDataService(),
      date: new Date(),
      month: new Date().getMonth(),
      year: new Date().getFullYear(),
      day: null,
      records: {},
      events: [],
      switchCustomerId: null,
      numOfRecords: 9,
      clicked: 0,
      totalRecords: 0
    };
  },
  watch: {
    defaultView: function() {
      this.fetchEventList();
    }
  },
  computed: {
    ...mapGetters(["isUserExternal", "userGroups"])
  },
  mounted() {
    const month = this.month + 1;
    const query = "year=" + this.year + "&month=" + month;

    const switchCustomerData = this.fetchSwitchCustomerCache();
    if (switchCustomerData != null) {
      this.switchCustomerId = switchCustomerData["switchCustomerNumber"];
    }

    this.fetchEventList(query);
  },
  methods: {
    formatDay(d) {
      if (d < 10) {
        return "0" + d;
      }
      return d;
    },
    totalRecordsCount(record) {
      if (record.length) return true;
      return false;
    },

    loadMore(e) {
      e.currentTarget.parentNode.previousSibling.style.display = "block";
    },

    isEmpty(deadline) {
      if (deadline && deadline.length) {
        return true;
      }

      return false;
    },
    eventByYear(year) {
      this.year = year;
      const month = this.month + 1;

      const query = "year=" + year + "&month=" + month;

      this.fetchEventList(query);
    },

    eventByMonth(month) {
      this.month = month;
      month = month + 1;
      const query = "year=" + this.year + "&month=" + month;

      this.fetchEventList(query);
    },

    eventByDay(date) {
      const month = date.getMonth() + 1;
      this.day = date.getDate();
      const query =
        "year=" + date.getFullYear() + "&month=" + month + "&day=" + this.day;

      this.records = {};
      this.date = date;
      this.fetchEventList(query);
    },

    fetchEventList(search = "") {
      /**
       * @vuese
       * fetch report ids with scheme deadline and data delivery deadline
       * @arg The argument is a search param(month, year)
       */
      const eventList = this.dashboardDataService.getEventList(
        this.defaultView,
        search,
        this.switchCustomerId
      );

      eventList.subscribe(
        response => {
          this.records = response.recordsInCalendar;

          if (this.day != null) {
            const date = new Date(this.year, this.month, this.day);
            const shortMonth = date.toLocaleString("en-us", { month: "short" });
            this.recordsDay = {};
            this.recordsDay[shortMonth] = {};
            this.recordsDay[shortMonth][this.day] = {
              Planned_scheme_deadline: [],
              Dataset_delivery_deadline: []
            };
            this.recordsDay[shortMonth][this.day][
              "Dataset_delivery_deadline"
            ] = this.records[shortMonth][this.day]["Dataset_delivery_deadline"];
            this.recordsDay[shortMonth][this.day][
              "Planned_scheme_deadline"
            ] = this.records[shortMonth][this.day]["Planned_scheme_deadline"];
            Object.assign(this.records, this.recordsDay);
          }
          this.totalRecords = Object.keys(this.records).length;
          this.day = null;
          const eventsCalendar = [];
          response.events.forEach(e =>
            eventsCalendar.push({ date: new Date(e.date), type: e.type })
          );

          this.events = eventsCalendar;
        },
        e => {
          console.log(e);
        }
      );
    }
  }
};
